import { ChildModalMode } from '@/features/shared/features/addOrEditChild/model/types';
import {
    useEditChild,
    useAddChild,
} from '@/features/shared/features/addOrEditChild/lib';

export const useAddOrEditChild = ({ mode }: { mode: ChildModalMode }) => {
    const addChild = useAddChild();
    const editChild = useEditChild();

    if (mode.isAdding) {
        return addChild;
    }

    if (mode.isEditing) {
        return editChild;
    }

    return {
        mutate: async () => Promise.resolve(), // No-op function as fallback
        status: 'idle',
        errorMessage: '',
        reset: () => {},
    };
};
